import { render, staticRenderFns } from "./DsfAddQuestion.vue?vue&type=template&id=01ec544f&"
import script from "./DsfAddQuestion.vue?vue&type=script&lang=js&"
export * from "./DsfAddQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\vsProject\\dsf-product-exam\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01ec544f')) {
      api.createRecord('01ec544f', component.options)
    } else {
      api.reload('01ec544f', component.options)
    }
    module.hot.accept("./DsfAddQuestion.vue?vue&type=template&id=01ec544f&", function () {
      api.rerender('01ec544f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/views/DsfAddQuestion.vue"
export default component.exports